import React from "react";
import { Box } from "@mui/material";

// TODO: Add useTheme hook to get the theme colors
interface MyDocumentsInfoCardItemProps {
  title: string;
  value: string | number;
}

export const MyDocumentsInfoCardItem = ({
  title,
  value,
}: MyDocumentsInfoCardItemProps) => {
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <Box
        style={{
          color: "#4D4D4D",
          fontSize: "12px",
          letterSpacing: "0.4px",
          width: "128px",
          textAlign: "right",
          paddingRight: "16px",
        }}
      >
        {title}
      </Box>
      <Box>{value}</Box>
    </Box>
  );
};

export default MyDocumentsInfoCardItem;
